import React from 'react';
import PropTypes from 'prop-types';
// import Members from 'src/components/general/Members';
import BreadcrumbsList from 'src/components/general/BreadcrumbsList';
import useStyles from './styles';
export default function BreadcrumbsBar(_ref) {
  let _ref$breadcrumbsArray = _ref.breadcrumbsArray,
    breadcrumbsArray = _ref$breadcrumbsArray === void 0 ? [] : _ref$breadcrumbsArray;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumbsBar
  }, /*#__PURE__*/React.createElement(BreadcrumbsList, {
    breadcrumbsArray: breadcrumbsArray
  }));
}
BreadcrumbsBar.propTypes = {
  breadcrumbsArray: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string
  })),
  showMembers: PropTypes.bool
};